import { Injectable, } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { LocalstorageService } from './localstorage.service';
import { EnvironmentService } from '../service/service.module';
import { CLIENT_INFO, USER_ID, USER_INFO, USER_ROLES, USER_TEAMS } from '@algomusinc/domain';

@Injectable()
export class LoggingService {
  environment = EnvironmentService.environment;
  appInsights: ApplicationInsights;

  contexts = {} as any;

  constructor(
    private storage: LocalstorageService,
  ) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: '4fcc9db7-366c-4b03-ae29-393bd18752a5', //this.environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  addToContext(key: string, value: any) {
    this.contexts[key] = value;
  }

  standardLogEventProps() {
    const event: any = {
      clientId: this.storage.get(CLIENT_INFO).tenantId,
      tenantName: this.storage.get(CLIENT_INFO).tenantName,
      origin: window.location.origin,
      userId: this.storage.get(USER_ID),
      userName: this.storage.get(USER_INFO).userName,
      firstName: this.storage.get(USER_INFO).firstName,
      lastName: this.storage.get(USER_INFO).lastName,
      userStatus: this.storage.get(USER_INFO).active,
      userRoles: this.storage.get(USER_ROLES).map((a: any) => a.roleName).join(','),
      userTeams: this.storage.get(USER_TEAMS).map((a: any) => a.teamName).join(',')
    };
    return event;
  }

  logPageView(page: any, props = {}) { // option to call manually
    const event = this.standardLogEventProps();
    this.appInsights.trackPageView({
      name: page.name,
      uri: page.selector,
      pageType: page.module,
      properties: {
        ...props,
        ...event,
        ...this.contexts
      }
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    const event = this.standardLogEventProps();
    this.appInsights.trackEvent({ name: name }, {
      ...properties,
      ...event,
      ...this.contexts
    });
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, {...properties, ...this.contexts});
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  /**
 * Logs a trace message with optional properties and severity level.
 * 
 * @param message - The trace message to log.
 * @param properties - Optional properties to include with the trace message.
 * @param severityLevel - The severity level of the trace message.
 *     - 0: Verbose
 *     - 1: Information
 *     - 2: Warning
 *     - 3: Error
 *     - 4: Critical
 */
  logTrace(message: string, properties?: { [key: string]: any }, severityLevel: 0 | 1 | 2 | 3 | 4 = 0) {
    this.appInsights.trackTrace({ message: message, severityLevel: severityLevel }, {...properties, ...this.contexts});
  }
}